<template>
  <div>
        <!-- <iframe src="https://docs.google.com/viewer?url=https%3A%2F%2Fmytimeline-dev.s3.ap-northeast-1.amazonaws.com%2Fmanual%2Foperating_manual.pdf&embedded=true" width="500px" height="700px"></iframe> -->
        <!-- <iframe src="https://mytimeline-dev.s3.ap-northeast-1.amazonaws.com/manual/operating_manual.pdf#toolbar=0&navpanes=0" frameborder="0" width="500px" height="650px"></iframe> -->
        <iframe src="https://mytimeline-dev.s3.ap-northeast-1.amazonaws.com/manual/operating_manual.pdf" frameborder="0" width="700px" height="770px"></iframe>
        <!-- <a href="https://mytimeline-dev.s3.ap-northeast-1.amazonaws.com/manual/operating_manual.pdf">manual</a> -->
        <!-- <img src="@/assets/print.pdf" alt=""> -->
        <!-- <img :src="operatingManual" alt=""> -->
        <!-- <p>test</p> -->
  </div>
</template>

<script>
// import IconImage from "@/img/push_icon.png";
// import om from "@/img/pdf/print.pdf"
export default {
    data() {
        return {
            // メッセージ
            message: "",
            operatingManual: "https://mytimeline-dev.s3.ap-northeast-1.amazonaws.com/manual/sample.pdf",
            // operatingManual: iconImage,
        }
    },
    mounted() {
    },
    methods: {
    }
}
</script>


<style scoped>
</style>